import { render, staticRenderFns } from "./OfficeSelectChoose.vue?vue&type=template&id=5cf24ddf&scoped=true&"
import script from "./OfficeSelectChoose.vue?vue&type=script&lang=js&"
export * from "./OfficeSelectChoose.vue?vue&type=script&lang=js&"
import style0 from "./OfficeSelectChoose.vue?vue&type=style&index=0&id=5cf24ddf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf24ddf",
  null
  
)

export default component.exports